import axios from 'axios';
import { statsUrl } from './conf';
import { Utils__param } from './utils';

export function api__stats(data, success, error) {
    return axios.post(statsUrl, data)
        .then(success)
        .catch(error);
}

export function api__weixin(success, error) {
    axios.get('//www.miui.com/bbshd/share/weixin')
        .then(success)
        .catch(error);
}

export function api__ELK404(data, success = () => { }, error = () => { }) {
  return axios.post(
      'https://r.browser.miui.com/log/uploadApiLog',
      Utils__param(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      },
    )
    .then(success)
    .catch(error);
}

export function api__elkLog(data, success=() => {}, error=() => {}) {
  return axios.post(
    'https://r.browser.miui.com/log/uploadlog',
    Utils__param(data),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    },
  )
  .then(success)
  .catch(error);
}

export function api__isXiangkanNews(data, success = () => {}, error = () => {}) {
    const param = {
      type: 'news',
      imei: data.imei,
      docId: data.docId,
    };

    return axios.get(`https://common.browser.miui.com/api/diversion/xk`, {
        params: param
      })
      .then(({data = {}}) => {
        if (data.code === 0 && data.data && data.data.existInXk) {
          success();
        } else {
          error()
        }
      })
      .catch(error);
}
